<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage Hotel Type</p>
    </header>
    <section class="modal-card-body">
        <b-field label="Name">
            <b-input
                type="text"
                v-model="hotelType.typeName"
                placeholder="e.g. Villa"
                required>
            </b-input>
        </b-field>
     
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageHotelTypes">Save</button>
    </footer>
  </div>
</template>

<script>
import HotetypeService from './service';

export default {
  name: 'ManageDestination',

  props: ['hotelType'],

  data() {
    return {
      isLoading: false,
      typeName : null,
    };
  },

  methods: {
        manageHotelTypes() {  
        this.isLoading = true;
        HotetypeService.manageHotelTypes( this.hotelType.docId, this.hotelType.typeName).then(() => {
        this.isLoading = false;
        //this.$bus.$emit('HOTELTYPE_UPDATE', typeName);
        this.$emit('close');
        this.$toast.open({
                    message: 'Hotel Type saved successfully',
                    type: 'is-success'
                });
                  location.reload();
      })
  } }
};
</script>



// WEBPACK FOOTER //
// src/pages/settings/ManageHoteltypes.vue